const membersValidation = {
  employeeAlias: {
    type: 'string',
    required: true,
  },
  fte: {
    type: 'number',
    required: true,
  },
  role: {
    type: 'string',
    required: true,
  },
  isBackup: {
    type: 'boolean',
    required: false,
  },
  isBench: {
    type: 'boolean',
    required: true,
  },
  startDate: {
    type: 'date',
    required: true,
  },
  endDate: {
    type: 'date',
    required: true,
  },
  minPercent: {
    type: 'number',
    required: true,
  },
  maxPercent: {
    type: 'number',
    required: true,
  },
  noteText: {
    type: 'string',
    required: false,
    maxLength: 255,
  },
};

const assignmentsValidation = {
  requiredFte: {
    required: true,
    type: 'number',
  },
  competencyLevel: {
    type: 'string',
    required: true,
  },
  positionId: {
    type: 'string',
    required: true,
  },
  technologyId: {
    type: 'string',
    required: {
      value: true,
      when: [
        {
          $positionId: {
            in: ['47', 47],
          },
        },
      ],
    },
  },
  requiredRole: {
    type: 'string',
    required: true,
  },
  members: {
    type: 'array',
    forEach: {
      type: 'object',
      _divisible: false,
      properties: membersValidation,
    },
  },
};

export const createTeamSlotValidation = {
  requiredFte: {
    required: true,
    type: 'number',
  },
  competencyLevel: {
    type: 'string',
    required: true,
  },
  positionId: {
    type: 'string',
    required: true,
  },
  technologyId: {
    type: 'string',
    required: {
      value: true,
      when: [
        {
          $positionId: {
            in: ['47', 47],
          },
        },
      ],
    },
  },
  requiredRole: {
    type: 'string',
    required: true,
  },
};

export default assignmentsValidation;
